import { Component, OnInit, OnDestroy } from '@angular/core';
import { Response } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager, ParseLinks, PaginationUtil, JhiLanguageService, AlertService } from 'ng-jhipster';

import { MarketdateComment } from './marketdate-comment.model';
import { MarketdateCommentService } from './marketdate-comment.service';
import { ITEMS_PER_PAGE, Principal } from '../../shared';
import { PaginationConfig } from '../../blocks/config/uib-pagination.config';

@Component({
    selector: 'jhi-marketdate-comment',
    templateUrl: './marketdate-comment.component.html'
})
export class MarketdateCommentComponent implements OnInit, OnDestroy {
marketdateComments: MarketdateComment[];
    currentAccount: any;
    eventSubscriber: Subscription;
    currentSearch: string;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private marketdateCommentService: MarketdateCommentService,
        private alertService: AlertService,
        private eventManager: EventManager,
        private activatedRoute: ActivatedRoute,
        private principal: Principal
    ) {
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['marketdateComment', 'commentType']);
    }

    loadAll() {
        if (this.currentSearch) {
            this.marketdateCommentService.search({
                query: this.currentSearch,
                }).subscribe(
                    (res: Response) => this.marketdateComments = res.json(),
                    (res: Response) => this.onError(res.json())
                );
            return;
       }
        this.marketdateCommentService.query().subscribe(
            (res: Response) => {
                this.marketdateComments = res.json();
                this.currentSearch = '';
            },
            (res: Response) => this.onError(res.json())
        );
    }

    search(query) {
        if (!query) {
            return this.clear();
        }
        this.currentSearch = query;
        this.loadAll();
    }

    clear() {
        this.currentSearch = '';
        this.loadAll();
    }
    ngOnInit() {
        this.loadAll();
        this.principal.identity().then((account) => {
            this.currentAccount = account;
        });
        this.registerChangeInMarketdateComments();
    }

    ngOnDestroy() {
        this.eventManager.destroy(this.eventSubscriber);
    }

    trackId(index: number, item: MarketdateComment) {
        return item.id;
    }
    registerChangeInMarketdateComments() {
        this.eventSubscriber = this.eventManager.subscribe('marketdateCommentListModification', (response) => this.loadAll());
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-comment/marketdate-comment.component.ts